import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { WHATSAPP_URL } from '../data/config';
import { trackEvent } from '../utils/metaPixel';
type WhatsAppButtonProps = {
  label?: string;
};
export function WhatsAppButton({
  label = 'Quiero hablar con un asesor'
}: WhatsAppButtonProps) {
  return <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('Contact')} className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-emerald-600 px-7 py-4 text-sm font-bold text-white transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-emerald-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 sm:text-base" data-id="element-282" data-mp="223v556h9d7di">
      <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-283" data-mp="2zr3x9kbrleoh" />
      {label}
    </a>;
}